import api from '../api/client';

const grant = async (payload) => {
    const res = await api.post('/api/delegation/grant', payload);
    return res?.data;
};

const revoke = async (delegationId) => {
    const res = await api.post('/api/delegation/revoke', {
        delegation_id: delegationId,
    });
    return res?.data;
};

const getMyDelegations = async (appId) => {
    const res = await api.get('/api/delegation/my-delegations', {
        params: { app_id: appId },
    });
    return res?.data?.data;
};

const getDelegatedToMe = async (appId) => {
    const res = await api.get('/api/delegation/delegated-to-me', {
        params: { app_id: appId },
    });
    return res?.data?.data;
};

const getAll = async (appId, params = {}) => {
    const res = await api.get('/api/delegation/all', {
        params: { app_id: appId, ...params },
    });
    return res?.data?.data;
};

// Server-paged lists for the Delegations data table, one per tab.
// `query` = { page, limit, sort, dir, search, filter_* }; each resolves to { results, pagination }.
const PAGE_ENDPOINTS = {
    all: '/api/delegation/all',
    granted: '/api/delegation/my-delegations',
    received: '/api/delegation/delegated-to-me',
};

const getPage = async (appId, tab, query) => {
    const res = await api.get(PAGE_ENDPOINTS[tab] || PAGE_ENDPOINTS.all, {
        params: { app_id: appId, ...query },
    });
    return res?.data?.data;
};

const update = async (payload) => {
    const res = await api.post('/api/delegation/update', payload);
    return res?.data;
};

const delegationsService = {
    grant,
    revoke,
    getMyDelegations,
    getDelegatedToMe,
    getAll,
    getPage,
    update,
};

export default delegationsService;
